import { render, staticRenderFns } from "./CommunitySelect.vue?vue&type=template&id=3d231570&scoped=true&"
import script from "./CommunitySelect.vue?vue&type=script&lang=js&"
export * from "./CommunitySelect.vue?vue&type=script&lang=js&"
import style0 from "./CommunitySelect.vue?vue&type=style&index=0&id=3d231570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d231570",
  null
  
)

export default component.exports